<template>
  <div class="app-select">
    <Field
      class="select-class"
      v-model="selectValue"
      is-link
      readonly
      :placeholder="$t('ep_admin_tips_select')"
      :disabled="disabled"
      @click="handleShow"
    />
    <Popup v-if="data.systemType === '1'" v-model:show="showPicker" round position="bottom">
      <Picker
        v-model="selectedValue"
        :columns="countryList"
        :columns-field-names="countryFieldName"
        @cancel="showPicker = false"
        @confirm="countryConfirm"
      />
    </Popup>
    <Popup v-if="data.systemType === '2'" v-model:show="showPicker" round position="bottom">
      <Picker
        v-model="selectedValue"
        :columns="stateList"
        :columns-field-names="stateFieldName"
        @cancel="showPicker = false"
        @confirm="stateConfirm"
      />
    </Popup>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { Popup, Picker, Field } from 'vant'
import { GetCountryList, GetStateList } from '@/services/marketing-management/form-management'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: String,
    default: undefined
  },
  countryValue: {
    required: false,
    type: String,
    default: undefined
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:value', 'change'])
const selectValue = ref(props.value)
const showPicker = ref(false)
const countryList = ref([])
const stateList = ref([])
const selectedValue = ref([])
const countryFieldName = {
  text: 'countryName',
  value: 'countryCode'
}
const stateFieldName = {
  text: 'provinceName',
  value: 'provinceCode'
}

const countryConfirm = ({ selectedOptions }) => {
  showPicker.value = false
  selectValue.value = selectedOptions[0].countryName
  emit('update:value', selectedOptions[0].countryCode)
  emit('change', selectedOptions[0].countryCode)
}

const stateConfirm = ({ selectedOptions }) => {
  showPicker.value = false
  selectValue.value = selectedOptions[0].provinceName
  emit('update:value', selectedOptions[0].provinceCode)
}
const handleShow = () => {
  if (props.disabled) return
  showPicker.value = true
}

const getStateList = async (val: any) => {
  const { data } = (await GetStateList({ countryCode: val })) || []
  stateList.value = data
  if (selectValue.value) {
    const result = stateList.value.some(item => item.provinceCode == selectValue.value)
    if (!result) {
      selectValue.value = undefined
      emit('update:value', undefined)
    } else {
      selectValue.value =
        stateList.value.find(item => item.provinceCode == props.data.fieldValue)?.provinceName ||
        props.data.fieldValue
    }
  }
}

watch(
  () => props.countryValue,
  value => {
    if (props.data.systemType === '2') {
      if (props.countryValue) {
        getStateList(props.countryValue)
      } else {
        stateList.value = []
      }
    }
  }
)

onMounted(async () => {
  if (props.data.systemType === '1') {
    const { data } = await GetCountryList()
    countryList.value = data
    if (props.data.fieldValue) {
      selectValue.value =
        countryList.value.find(item => item.countryCode === props.data.fieldValue)?.countryName ||
        props.data.fieldValue
      emit('change', props.data.fieldValue)
    }
    selectedValue.value = props.data.fieldValue ? [props.data.fieldValue] : []
  } else {
    selectedValue.value = props.data.fieldValue ? [props.data.fieldValue] : []
  }
})
</script>

<style lang="less" scoped>
.app-select {
  width: 100%;
  .select-class {
    display: flex;
    align-items: center;
    height: 32px;
    line-height: 32px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    padding: 0 8px;
  }
}
</style>
